import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

import {BehaviorSubject, Subject} from 'rxjs';

import {ErrorsObject} from '../../../shared/utilities/error-utility.utility';
import * as fromModuleModels from '../../models';
import {FormsService} from '../../../shared/services';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'storage-location-form',
  styleUrls: ['storage-location-form.component.scss'],
  template: `

    <div class="card mat-elevation-z1">

      <div class="card__heading">
        <span>{{ presets$.getValue() ? 'Lagerplatz bearbeiten' : 'Neuen Lagerplatz anlegen' }}</span>
      </div>

      <div class="card__content">
        <form [formGroup]="slf" (ngSubmit)="handleSubmit()">

          <div class="grid">
            <div class="column-14">
              <mat-form-field>
                <mat-label>Lagerplatz-Nummer</mat-label>
                <input type="text" matInput formControlName="storageLocationNumber" required>
                <mat-hint align="start"
                          *ngIf="errors?.storageLocationNumber">{{ errors.storageLocationNumber.message }}</mat-hint>
              </mat-form-field>
            </div>

            <div class="m-ta--2 column-14">

              <button *ngIf="presets$.getValue() || slf.dirty" class="m-r--16" (click)="cancelEdit()" type="button"
                      color="outline" mat-flat-button>
                <mat-icon class="m-r--8">cancel</mat-icon>
                <span>Abbrechen</span>
              </button>

              <button [disabled]="slf.invalid || slf.untouched" mat-flat-button color="green">
                <mat-icon class="m-r--8">save</mat-icon>
                <span>{{ presets$.getValue() ? 'Aktualisieren' : 'Anlegen' }}</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  `
})
export class StorageLocationFormComponent implements OnInit {

  @Input()
  errors: ErrorsObject;

  @Input()
  presets$: BehaviorSubject<any>;

  @Output()
  requestCreateItem: EventEmitter<{ payload: fromModuleModels.StorageLocation, entity: string }>
    = new EventEmitter<{ payload: fromModuleModels.StorageLocation, entity: string }>();

  @Output()
  requestUpdateItem: EventEmitter<{ iri: string, payload: fromModuleModels.StorageLocation, entity: string }>
    = new EventEmitter<{ iri: string, payload: fromModuleModels.StorageLocation, entity: string }>();

  slf: FormGroup;

  onDestroy$: Subject<any> = new Subject<any>();

  constructor(private fb: FormBuilder, private fs: FormsService) {
  }

  ngOnInit(): void {
    this.presets$.pipe(
      takeUntil(this.onDestroy$),
    ).subscribe(preset => {
      this.initForm();
      this.fs.patchForm(this.slf, preset);
      this.slf.markAsUntouched();
    });
  }

  initForm() {
    this.slf = this.fb.group({
      storageLocationNumber: this.fb.control(null, [Validators.required, Validators.minLength(1)])
    });
  }

  cancelEdit() {
    this.initForm();
    this.presets$.next(null);
  }

  handleSubmit(): void {

    const payload: fromModuleModels.StorageLocation = this.slf.value;

    !this.presets$.getValue()
      ? this.requestCreateItem.emit({payload, entity: 'StorageLocation'})
      : this.requestUpdateItem.emit({iri: this.presets$.getValue()['@id'], payload, entity: 'StorageLocation'});
  }
}
